export default "__VITE_ASSET__MF0PwFx7__"